import { useEffect } from 'react';
import { useLocation } from '@tanstack/react-router';
import { consumeSkipScrollReset, consumePopStateNavigation } from './scrollResetControl';

export const useScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    // 遷移元がスクロール位置を自前で復元する遷移（skipNextScrollReset 呼び出し済み）と
    // ブラウザバック/フォワードではリセットしない
    const skipReset = consumeSkipScrollReset();
    const isPopState = consumePopStateNavigation();
    if (skipReset || isPopState) return undefined;

    const resetScrollPosition = () => {
      // ルート変更時にスクロール位置を一番上にリセット
      window.scrollTo(0, 0);

      const mainContent = document.querySelector('[data-scroll-container]');
      if (mainContent) {
        mainContent.scrollTop = 0;
      }

      const scrollableElements = document.querySelectorAll('.overflow-y-auto, .hidden-scrollbar');
      scrollableElements.forEach((element) => {
        element.scrollTop = 0;
      });
    };

    resetScrollPosition();

    const timeoutId = setTimeout(resetScrollPosition, 100);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [location.pathname, location.search]);
};
